exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center[data-v-5606e817]{position:fixed;top:50%;left:50%;margin-top:-50px;margin-left:-100px}", ""]);

// exports
